import { Material } from "../models/material";
import { Measurement } from "../models/measurement";
import { ItemJob } from "../models/sales";
import { handleGetConvertValue, Metric } from "./converts";
import { DESTINATION, ItemJobStatus } from "./enums";

export const calculateTotalVolume = (
  subStatusItem: string,
  measurement?: Measurement,
  itemsJob?: ItemJob[],
  materials?: Material[],
  decimals?: number
) => {
  let total = 0;

  const itemsJobFiltered =
    itemsJob && itemsJob?.length > 0
      ? itemsJob?.filter((itemJob) => itemJob?.subStatus === subStatusItem)
      : [];

  if (itemsJobFiltered && itemsJobFiltered?.length > 0) {
    for (const itemJob of itemsJobFiltered) {
      if (
        !itemJob?.destination?.name?.includes(DESTINATION.NOT_GOING) &&
        itemJob?.status !== ItemJobStatus.VOID
      ) {
        total += Number(Number(itemJob?.quantity || 1) * Number(itemJob?.volume || 0)) || 0;
      }
    }
  }

  if (materials && materials?.length > 0) {
    for (const material of materials) {
      if (
        material?.serviceBooking?.isItem &&
        !material?.destination?.name?.includes(DESTINATION.NOT_GOING)
      ) {
        total += Number(Number(material?.quantity || 1) * Number(material?.volume || 0)) || 0;
      }
    }
  }

  return `${handleGetConvertValue(total, measurement?.code || "", decimals ?? measurement?.decimalPlaces)} ${
    measurement?.code || Metric["m³"]
  }`.trim();
};
